import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule} from '@angular/material/progress-bar';

import { DeletePlanModule } from '../context-components/delete-plan/delete-plan.module';
import { DeleteConfirmationModule } from '../context-components/delete-confirmation/delete-confirmation.module';

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    DeletePlanModule,
    DeleteConfirmationModule,
    HomeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatListModule,
    MatTableModule,
    MatTooltipModule,
    MatIconModule,
    MatProgressBarModule
  ]
})
export class HomeModule { }
